<p-menubar [model]="mbitems">
	<button pButton type="button" label="Clients" [routerLink]="['/clientsearch']"></button>&nbsp;
	<button pButton type="button" label="New Leads" [routerLink]="['/newleads']"></button>&nbsp;
	<button pButton type="button" label="Bookings" [routerLink]="['/bookings/list']"></button>&nbsp;
	<button pButton type="button" label="Reports" [routerLink]="['/reports/summary']"></button>&nbsp;
 </p-menubar>